export const FEATURE_FLAG_COOKIE_NAME = 'x-flag'
export const FEATURE_FLAG_HEADER_NAME = 'X-Flag'

export const flags = {
  FLAG_FOR_TESTING: 'pga-com-flag-for-testing',
  FLAG_COACHES_SEARCH_PRIORITY: 'pga-com-coaches-search-priority',
  FLAG_MARKETING_OPT_IN_EXP: 'pga-com-exp-marketing-opt-in',
  FLAG_AGE_SPECIFIC_GROUP: 'pga-com-age-specific-group-event',
  FLAG_MARKETING_OPT_IN_WAITLIST: 'pga-com-marketing-opt-in-waitlist',
  FLAG_MEMBERS_DIFFERENTIATION: 'pga-com-members-non-members-differentiation',
  FLAG_CUSTOM_PAGE: 'pga-com-custom-page',
  FLAG_COACH_PLUS_BANNER: 'pga-com-coach-plus-banner',
  FLAG_COACH_SEARCH_REDIRECT: 'pga-com-coach-search-redirect',
  FLAG_SEARCH_PRECISION_RANGES: 'pga-com-search-precision-ranges',
  FLAG_COACH_SEARCH_PRECISION_EXPERIMENT: 'pga-com-coach-search-precision-experiment',
  FLAG_COACH_TOOLS_ENDORSEMENT: 'pga-com-coach-tools-endorsement',
}
